import { clearData } from "./clearData";
import { CategoryDexie } from "../interfaces/categoryDexie";

export async function addCategories(categories: CategoryDexie[], thisCategories): Promise<void> {
    await clearData(thisCategories)
    await thisCategories.bulkPut(categories);
}
